import React, { useState } from "react";
import "../list.less";
import "./mapComponent.less";
import { Icon_Close } from "../../../BP2Components/Icons/icons";
import { Button, Modal } from "../../../BP2Components";
import FormComplete from "../../../FormsV2/FormComplete";
import { useIntl } from "react-intl";
import IntlMessages from "../../../../util/IntlMessages";
import { googleNav } from "../../../../util/actions/googleNav";
import { handleProcessAction } from "../../../../util/actions/process";

const ListMapPositionMarker = ({
   onClick,
   markUrl,
   group,
   isOpenAction,
   markerName,
   onCloseAction,
   allActions,
   markerId,
   setMarkerId,
   isSelected,
}) => {
   const intl = useIntl();
   const [openAdditionalActions, setOpenAdditionalActions] = useState(false);
   const [currentAction, setCurrentAction] = useState(null);
   const markerLabel =
      typeof markerName === "object" && markerName !== null ? (markerName.value ?? "") : markerName;

   const renderActionButton = (actionButton) => {
      const handleClick = () => {
         switch (actionButton?.type) {
            case "FORM":
               return setCurrentAction({
                  formId: actionButton.formID,
                  actionId: actionButton.id,
                  dataId: markerId,
               });
            case "GOOGLE_NAV":
               return googleNav({ actionId: actionButton.id, recordId: markerId, intl });
            case "PROCESS":
               return handleProcessAction(actionButton, markerId);
            default:
               return null;
         }
      };

      return (
         <Button key={actionButton.id} className="dropdown-button-item" onClick={handleClick}>
            {actionButton.label}
         </Button>
      );
   };

   const buttons = Array.isArray(allActions) ? allActions.map(renderActionButton) : [];

   const handleClose = () => {
      onCloseAction(null);
      setMarkerId(null);
      setOpenAdditionalActions(false);
      setCurrentAction(null);
   };

   const handleCloseModal = () => {
      setCurrentAction(null);
   };

   const handleSaveForm = () => {
      setCurrentAction(null);
      setMarkerId(null);
   };

   return (
      <>
         {markUrl && group === false ? (
            <button className="position-marker-img" onMouseUp={onClick} onTouchEnd={onClick}>
               <img src={markUrl} className="marker-img" alt="marker-img" />
            </button>
         ) : (
            <div style={{ position: "relative" }}>
               <button
                  className={`position-marker ${isOpenAction ? "active" : ""} ${isSelected ? "selected" : ""}`}
                  onMouseUp={onClick}
                  onTouchEnd={onClick}
               >
                  <div className="dot">
                     <div className="tail"></div>
                  </div>
               </button>
               {isOpenAction ? (
                  <div className="action-tab">
                     <div className="action-tab__header">
                        <button className="position-marker" style={{ top: -3, left: 0 }}>
                           <div className="dot">
                              <div className="tail"></div>
                           </div>
                        </button>
                        <span className="action-tab__marker-name" style={{ minWidth: 200 }}>
                           {markerLabel}
                        </span>
                        <button onClick={handleClose} className="action-button-close">
                           <Icon_Close fill="none" stroke="#64748B" />
                        </button>
                     </div>
                     <button
                        className="action-button"
                        onClick={() => setOpenAdditionalActions(!openAdditionalActions)}
                     >
                        <IntlMessages id="global.actions" />
                        <span
                           style={{
                              marginLeft: 8,
                              fontSize: 22,
                              position: "absolute",
                              top: 0,
                              right: "5%",
                           }}
                        >
                           ›
                        </span>
                     </button>
                     {openAdditionalActions ? (
                        <div className="action-button-wrapper">{buttons}</div>
                     ) : null}
                  </div>
               ) : null}
            </div>
         )}
         {currentAction ? (
            <Modal
               isOpen={!!markerId}
               onCancel={handleCloseModal}
               width={560}
               height={540}
               topBarContent={
                  <p className="p1" style={{ margin: "0", paddingRight: "1rem" }}>
                     {markerLabel}
                  </p>
               }
            >
               <FormComplete
                  actionId={currentAction.actionId}
                  recordId={currentAction.dataId}
                  saveCallback={handleSaveForm}
               />
            </Modal>
         ) : null}
      </>
   );
};

export default ListMapPositionMarker;
